import { hasCapability } from "@vninvestcharts/engine-core";
export const CHART_TYPE_OPTIONS = [
    { value: "candlestick", labelKey: "chartType.candlestick" },
    { value: "line", labelKey: "chartType.line" },
    { value: "area", labelKey: "chartType.area" },
    { value: "heikinAshi", labelKey: "chartType.heikinAshi" },
    // Gỡ 2026-10-03: `bar` bị gỡ khỏi picker. `Bar` là chart type giá nhưng tên nó
    // trùng với heuristic `type.includes("bar")` của engine, nên nó bị định tuyến
    // vào mode zero-based của volume ⇒ mọi cột vẽ từ 0 tới close, trục Y chạy
    // 0→100.000 và biến động giá nén trong ~8% trên cùng. `OHLC` đã render đúng
    // chart nến-tick (wick low→high, tick open/close) nên không mất khả năng nào.
    // Ledger `WA_BAR_RUNTIME_2026-10-03`.
    // A3 Baseline / A11 Renko / Kagi / Point & Figure / Line Break: đã có producer
    // + case resolver + render mode ở engine, nên KHÔNG còn `comingSoon`. Cổng là
    // capability pro, không phải "chưa làm" — xem `core/registry/priceChartTypes.ts`
    // cho tầng render.
    { value: "baseline", labelKey: "chartType.baseline", capability: "chart_baseline" },
    { value: "renko", labelKey: "chartType.renko", capability: "chart_exotic" },
    { value: "kagi", labelKey: "chartType.kagi", capability: "chart_exotic" },
    { value: "pointAndFigure", labelKey: "chartType.pointAndFigure", capability: "chart_exotic" },
    { value: "lineBreak", labelKey: "chartType.lineBreak", capability: "chart_exotic" },
    { value: "hollow", labelKey: "chartType.hollow" },
    { value: "ohlc", labelKey: "chartType.ohlc" },
];
/** Tier chưa xác minh được (`null`/`undefined`) ⇒ khoá, không phải mở. */
export function isChartTypeLocked(option, patTier) {
    if (option.comingSoon === true) {
        return true;
    }
    return option.capability !== undefined && !hasCapability(patTier, option.capability);
}
/** Đã khai báo trong `CHART_TYPE_OPTIONS` nhưng chưa build (khác với "bị khoá theo tier"). */
export function isChartTypeComingSoon(option) {
    return option.comingSoon === true;
}
